import { memo } from 'react';
import { styled } from '@mui/material/styles'
import {
    Drawer,
    Box,
    IconButton,
    Typography,
    List,
    ListItem,
    ListItemIcon
} from '@mui/material'
import { ReactComponent as BackArrowIcon } from "../../assets/icons/icon-back-arrow.svg"
import Scrollbar from '../../components/Scrollbar'
import reportSidebarConfig from '../report/ReportSideBarConfig';
import { Link } from 'react-router-dom';

const DRAWER_WIDTH = 145
const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        //flexShrink: 0,
        //width: DRAWER_WIDTH,
    },
}))

const ReportSidebarNew = ({isOpenSidebar, onCloseSidebar, onOpenSidebar,selectedSidebarMenu}) => {
    const handleSettingSelection = (menu) => {
        if (isOpenSidebar && selectedSidebarMenu === menu.title) {
            onCloseSidebar(menu)
        } else {
            onOpenSidebar(menu)
        }
    }

    return <RootStyle>
        <Drawer className="report-sidebar" variant="permanent" sx={{ width: DRAWER_WIDTH }}>
            <Box className="report-sidebar-back-btn" >
                <IconButton component={Link} to={'/report'} className="report-new-back-button">
                    <BackArrowIcon />
                    <Typography variant="span" className="text-plain" sx={{ fontWeight: '500' }} pl={1} >Back</Typography>
                </IconButton>
            </Box>
            <Scrollbar
                sx={{
                    height: '100%',
                    '& .simplebar-content': {
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        width: DRAWER_WIDTH,
                    },
                }}
                className="report-left-nav-scroll"
            >
                <List className="reports-left-nav">
                    {reportSidebarConfig.map((menu, index) => (
                        <ListItem button key={menu.title} className={`cm_rprt_sidebar report-new-sidebar-item ${selectedSidebarMenu === menu.title ? 'report_slctd_sidebar_menu' : ''}`} onClick={() => handleSettingSelection(menu)} >
                            <ListItemIcon className="cm_rprt_sidebar_icon report-new-sidebar-item-icon"> {menu.icon} </ListItemIcon>
                            <Typography className="report-new-sidebar-item-text" variant="body2"> {menu.title} </Typography>
                        </ListItem>
                    ))}
                </List>
            </Scrollbar>
        </Drawer>
    </RootStyle>
}

export default memo(ReportSidebarNew)